<ng-container [ngSwitch]="configType">
  <ng-container *ngSwitchCase="'icon'">
    <nibtravel-link-icon
      [icon]="config"
      [linkUrl]="linkUrl()"
      class="logo-link"
    >
    </nibtravel-link-icon>
  </ng-container>

  <ng-container
    *ngSwitchCase="logoType.SVG"
    [ngTemplateOutlet]="logo"
    [ngTemplateOutletContext]="{ template: svg }"
  >
  </ng-container>

  <ng-container
    *ngSwitchCase="logoType.Image"
    [ngTemplateOutlet]="logo"
    [ngTemplateOutletContext]="{ template: img }"
  >
  </ng-container>
</ng-container>

<ng-template #logo let-template="template">
  <ng-container *ngIf="config.link; else template">
    <a
      class="logo-link"
      [rel]="logoConfig?.rel ? logoConfig?.rel : 'noopener'"
      [href]="config.link"
      [target]="logoConfig?.linkTarget ? logoConfig?.linkTarget : '_blank'"
    >
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </a>
  </ng-container>
</ng-template>

<ng-template #svg>
  <svg class="logo">
    <title>{{ logoSvg?.alt }}</title>
    <use attr.xlink:href="{{ logoSvg?.src }}"></use>
  </svg>
</ng-template>

<ng-template #img>
  <img class="logo" [src]="logoImage?.src" [alt]="logoImage?.alt" />
</ng-template>
